import Vue from "vue";
const state = {
    user_info_type: localStorage.getItem("user_info_type") || '',
    user_locations: [],
    is_login: false,
    is_in_alert: false,
    is_qr_code: false,
    is_vanti_qr_code: false,
    is_complete_registration: false,
    navigation_drawer: false,
    alert_message: '',
    device_id: '',
    user_token: localStorage.getItem("user_token") || null,
    image_server: '',
    tags: [],
    categories: [],
    locations: [],
    offers: [],
    loader: true,
    user_id: null,
    user_type: "",
    email_user: localStorage.getItem("email_user") || '',
    dashboard_active: 0,
    location_time_zone: "",
    sublocation_id: null,
    booking_date: null,
    capacity_validator: false,
    user_id_encrypt: localStorage.getItem("user_id_encrypt") || null,
    scan_devices_ips: [],
    scan_devices_sockets: null,
    user_roles: localStorage.getItem("user_roles") || [],
    name_user: localStorage.getItem("name_user") || '',
    company_loaded: true,
    payment_method: '',
    selected_task: '',
    company:{
        id:'',
        user_name: '',
        description:"",
        document_number: "",
        email: "",
        company_name: "",
        address: "",
        identify_number: "",
        has_booking_locations: false,
        max_time_exceeded_blocking: false,
        directory: false,
        dashboard:{
          users: true,
          offers: true,
          rewards: true,
          access: true
        },
        offers:{
          redemption_form:"",
          favorites: true
        },
        rewards:{
          user_characteristics: true,
          segments: true,
          rewards: true
        },
        access:{
          general_access:'',
          without_internet_access: false,
          keyboard_access: false,
          dynamic_invitations: true,
          room_bookings: '',
          courtesies: true,
          covenants: true,
          reports: true,
          alerts: true,
          counter: true,
          user_access: true,
          virtual_guard: false,
          notify_access: false
        },
        sgsst:{
          general: false
        },
        locations:{
          offers_and_rewards: true,
          sublocations: {
            time_out: false,
            bookings: true
          },
          holidays: false
        },
        personal_trainer:{
          personal_trainer: true
        },
        messages:{
          notifications:false,
          segment_mails: false
        },
        news:{
          general_news: true,
          video_news: true,
          twits_news: true
        },
        events:{
          tickets: true
        },
        company_connections:{
          company_connections: false
        },
        client_information: {
          us: false,
          contact_us: false
        },
        personalize:{
          web_page: false,
          mobile_app: false,
          colors: {
            principal: '#0076FF',
            secundary:'#09CA6C'
          },
          app_logo: '',
          principal_sections: [],
          secondary_sections: [],
          personalize_mails: false
        },
        inside_request:{
          payment_certificate: false,
          work_certificate: false,
          contribution_certificate: false
        },
        api_connections:{
          crm: false,
          end_points: false
        },
        invitations:{
            admin_invitations: false
        }
    },
    session_company_id: localStorage.getItem("session_company_id") || null,
    user_is_approver: localStorage.getItem("user_is_approver") || false,
}

const getters = {
    getUserIsApprover(state){
        return state.user_is_approver
    },
    getUserLocations(state){
        return state.user_locations
    },
    getUserInfoType(state){
        return state.user_info_type
    },
    getIsLogin(state) {
        return !!state.user_token;
    },
    getIsInAlert(state) {
        return state.is_in_alert
    },
    getIsQrCode(state) {
        return state.is_qr_code
    },
    getIsCompleteRegistration(state) {
        return state.is_complete_registration
    },
    getAlertMessage(state) {
        return state.alert_message
    },
    getDeviceId(state) {
        return state.device_id
    },
    getUserToken(state) {
        return state.user_token
    },
    getImageServer(state) {
        return state.image_server
    },
    getTags(state) {
        return state.tags
    },
    getCategories(state) {
        return state.categories
    },
    getLocations(state) {
        return state.locations
    },
    getOffers(state) {
        return state.offers
    },
    getLoader(state) {
        return state.loader
    },
    getUserId(state) {
        return state.user_id
    },
    getUserType(state) {
        return state.user_type
    },
    getEmailUser (state) {
        return state.email_user
    },
    getNameUser (state) {
        return state.name_user
    },
    getDashboardActive(state) {
        return state.dashboard_active
    },
    getCapacityValidator(state) {
        return state.capacity_validator
    },
    getUserIdEncrypt(state){
        return state.user_id_encrypt
    },
    getCompany(state){
        return state.company
    },
    getScanDevicesIps(state){
        return state.scan_devices_ips
    },
    getScanDevicesSockets(state){
        return state.scan_devices_sockets
    },
    getUserRoles(state){
        return state.user_roles
    },
    getSublocationId(state) {
        return state.sublocation_id
    },
    getBookingDate(state) {
        return state.booking_date
    },
    getCompanyLoaded(state) {
        return state.company_loaded
    },
    getSessionCompanyId(state) {
        return state.session_company_id
    },
    getIsVantiQrCode(state) {
        return state.is_vanti_qr_code
    },
    getPaymentMethod(state){
        return state.payment_method
    },
    getSelectedTask(state){
        return state.selected_task
    },
}

const mutations = {
    setUserLocations: function(state, payload){
        state.user_locations = payload
    },
    setUserInfoType: function(state, payload){
        state.user_info_type = payload
        localStorage.setItem('user_info_type',payload)
    },
    setIsLogin: function(state, payload) {
        state.is_login = payload
    },
    setIsInAlert: function(state, payload) {
        state.is_in_alert = payload
    },
    setIsQrCode: function(state, payload) {
        state.is_qr_code = payload
    },
    setIsCompleteRegistration: function(state, payload) {
        state.is_complete_registration = payload
    },
    setAlertMessage: function(state, payload) {
        state.alert_message = payload
    },
    setDeviceId(state, payload) {
        state.device_id = payload
    },
    setUserToken(state, payload) {
        state.user_token = payload
        localStorage.setItem("user_token", payload);
    },
    setImageServer(state, payload) {
        state.image_server = payload
    },
    setTags(state, payload) {
        state.tags = payload
    },
    setCategories(state, payload) {
        state.categories = payload
    },
    setLocations(state, payload) {
        state.locations = payload
    },
    setOffers(state, payload) {
        state.offers = payload
    },
    setLoader(state, payload) {
        state.loader = payload
    },
    setUserId(state, payload) {
        state.user_id = payload
    },
    setUserType(state, payload) {
        state.user_type = payload
    },
    setEmailUser: function (state, payload) {
        state.email_user = payload
        localStorage.setItem('email_user',payload)
    },
    setNameUser: function (state, payload) {
        state.name_user = payload
        localStorage.setItem('name_user',payload)
    },
    setDashboardActive(state, payload) {
        state.dashboard_active = payload
    },
    setCapacityValidator(state, payload) {
        state.capacity_validator = payload
    },
    setUserIdEncrypt: function (state, payload) {
        state.user_id_encrypt = payload
        localStorage.setItem('user_id_encrypt',payload)
    },
    setCompany(state, payload) {
        state.company = payload
    },
    setScanDevicesIps(state, payload) {
        state.scan_devices_ips = payload
    },
    setScanDevicesSockets(state, payload) {
        state.scan_devices_sockets = payload
    },
    setUserRoles(state, payload) {
        state.user_roles = payload
        localStorage.setItem('user_roles',payload)
    },
    setSublocationId: function(state, payload) {
        state.sublocation_id = payload
        sessionStorage.setItem('sublocation_id', payload)
    },
    setBookingDate: function(state, payload) {
        state.booking_date = payload
        sessionStorage.setItem('booking_date', payload)
    },
    setCompanyLoaded: function(state, payload) {
        state.company_loaded = payload
    },
    setSessionCompanyId: function(state, payload) {
        state.session_company_id = payload
        localStorage.setItem('session_company_id', payload)
    },
    setIsVantiQrCode: function(state, payload) {
        state.is_vanti_qr_code = payload
    },
    setPaymentMethod: function(state, payload){
        state.payment_method = payload
    },
    setSelectedTask: function(state, payload){
        state.selected_task = payload
    },
    setUserIsApprover: function(state, payload){
        state.user_is_approver = payload
        localStorage.setItem('user_is_approver', payload)
    },
}

const actions = {
    updateUserIsApprover: function({ commit }, payload){
        commit('setUserIsApprover', payload)
    },
    updateUserLocations: function({ commit }, payload){
        commit('setUserLocations', payload)
    },
    updateUserInfoType: function({ commit }, payload){
        commit('setUserInfoType', payload)
    },
    updateIsLogin: function({ commit }, payload) {
        commit('setIsLogin', payload)
    },
    updateIsInAlert({ commit }, payload) {
        commit('setIsInAlert', payload)
    },
    updateIsQrCode: function({ commit }, payload) {
        commit('setIsQrCode', payload)
    },
    updateIsCompleteRegistration: function({ commit }, payload) {
        commit('setIsCompleteRegistration', payload)
    },
    updateAlertMessage({ commit }, payload) {
        commit('setAlertMessage', payload)
    },
    updateDeviceId({ commit }, payload) {
        commit('setDeviceId', payload)
    },
    updateUserToken({ commit }, payload) {
        commit('setUserToken', payload)
    },
    updateImageServer({ commit }, payload) {
        commit('setImageServer', payload)
    },
    updateTags({ commit }, payload) {
        commit('setTags', payload)
    },
    updateCategories({ commit }, payload) {
        commit('setCategories', payload)
    },
    updateLocations({ commit }, payload) {
        commit('setLocations', payload)
    },
    updateAllLocations({ commit }, payload) {
        commit('setAllLocations', payload)
    },
    updateOffers({ commit }, payload) {
        commit('setOffers', payload)
    },
    updateLoader({ commit }, payload) {
        commit('setLoader', payload)
    },
    updateUserId({ commit }, payload) {
        commit('setUserId', payload)
    },
    updateUserType({ commit }, payload) {
        commit('setUserType', payload)
    },
    updateEmailUser: function ({commit}, payload) {
        commit('setEmailUser', payload)
    },
    updateNameUser: function ({commit}, payload) {
        commit('setNameUser', payload)
    },
    updateDashboardActive({ commit }, payload) {
        commit('setDashboardActive', payload)
    },
    updateCapacityValidator({ commit }, payload) {
        commit('setCapacityValidator', payload)
    },
    updateUserIdEncrypt: function ({commit}, payload) {
        commit('setUserIdEncrypt', payload)
    },
    updateCompany: function ({commit}, payload) {
        commit('setCompany', payload)
    },
    updateScanDevicesIps({commit}, payload) {
        commit('setScanDevicesIps', payload)
    },
    updateScanDevicesSockets({commit}, payload) {
        commit('setScanDevicesSockets', payload)
    },
    updateUserRoles({commit}, payload) {
        commit('setUserRoles', payload)
    },
    updateSublocationId: function({ commit }, payload) {
        commit('setSublocationId', payload)
    },
    updateBookingDate: function({ commit }, payload) {
        commit('setBookingDate', payload)
    },
    updateCompanyLoaded: function({ commit }, payload) {
        commit('setCompanyLoaded', payload)
    },
    updateSessionCompanyId: function({ commit }, payload) {
        commit('setSessionCompanyId', payload)
    },
    updateIsVantiQrCode: function({ commit }, payload) {
        commit('setIsVantiQrCode', payload)
    },
    updatePaymentMethod: function({ commit }, payload){
        commit('setPaymentMethod', payload)
    },
    updateSelectedTask: function({ commit }, payload){
        commit('setSelectedTask', payload)
    },
    updateCustomCompany({commit, dispatch}, {id, email}){
        var self=this;
        return new Promise(async(resolve, reject) => {

            try {
                Vue.http.get("companies/"+id)
          .then((response) =>{
                dispatch("updateCompanyLoaded",false)
                const dataCompany = response.body.data.attributes;

                if(dataCompany.locations_sublocations == null){
                self.sublocations = {
                        time_out: false,
                        bookings: false
                    }
                }else{
                self.sublocations = {
                        time_out: dataCompany.locations_sublocations.time_out == null ? dataCompany.locations_sublocations.time_out : '',
                        bookings: dataCompany.locations_sublocations.bookings == null ? dataCompany.locations_sublocations.bookings : ''
                    }
                }
                if(dataCompany.personalize_colors == null){
                    self.colors = {
                        principal: '#0076FF',
                        secundary: '#09CA6C'
                    }        }else{
                    self.colors = {
                        principal: dataCompany.personalize_colors.principal,
                        secundary: dataCompany.personalize_colors.secundary
                    }
                }
            var company =  {
                id:response.body.data.id,
                user_name: '',
                description:dataCompany.description != null ? dataCompany.description : '',
                document_number: "",
                email: email,
                company_name: dataCompany.name,
                address: dataCompany.address != null ? dataCompany.address : '',
                identify_number: dataCompany.identify_number,
                max_time_exceeded_blocking: dataCompany.max_time_exceeded_blocking != null ? dataCompany.max_time_exceeded_blocking : false,
                directory: dataCompany.client_information_directory,
                dashboard:{
                    users: dataCompany.dashboard_users,
                    offers: dataCompany.dashboard_offers,
                    rewards: dataCompany.dashboard_rewards,
                    access: dataCompany.dashboard_access
                },
                offers:{
                    redemption_form: dataCompany.offers_redemption_form != null ? dataCompany.offers_redemption_form : '',
                    favorites: dataCompany.offers_favorites
                },
                rewards:{
                    user_characteristics: dataCompany.rewards_user_characteristics,
                    segments: dataCompany.rewards_segments,
                    rewards: dataCompany.rewards_rewards
                },
                access:{
                    general_access: dataCompany.access_general_access != null ? dataCompany.access_general_access : false,
                    without_internet_access: dataCompany.access_without_internet_access,
                    keyboard_access: dataCompany.access_keyboard_access,
                    dynamic_invitations: dataCompany.access_dynamic_invitations,
                    room_bookings: dataCompany.access_room_bookings != null ? dataCompany.access_room_bookings : false,
                    courtesies: dataCompany.access_courtesies,
                    covenants: dataCompany.access_covenants,
                    reports: dataCompany.access_reports,
                    alerts: dataCompany.access_alerts,
                    counter: dataCompany.access_counter,
                    user_access:dataCompany.access_user_access,
                    virtual_guard: dataCompany.access_virtual_guard,
                    notify_access: dataCompany.access_notify_access,
                    device_administration: dataCompany.access_device_administration,
                    remote_open_door: dataCompany.access_remote_open_door,
                    invitation_approved: dataCompany.access_invitation_approved
                },
                locations:{
                    offers_and_rewards: dataCompany.location_offers_and_rewards,
                    sublocations:self.sublocations,
                    holidays: dataCompany.locations_holidays,
                    associated_locations: dataCompany.locations_associated_locations
                },
                personal_trainer:{
                    personal_trainer: dataCompany.personal_trainer_classes
                },
                messages:{
                    notifications: dataCompany.messages_notifications,
                    segment_mails: dataCompany.messages_segment_mails
                },
                news:{
                    general_news: dataCompany.news_general_news,
                    video_news: dataCompany.news_video_news,
                    twits_news: dataCompany.news_twits_news
                },
                events:{
                    tickets: dataCompany.events_tickets
                },
                company_connections:{
                    company_connections: dataCompany.company_connections_company_connections
                },
                client_information: {
                    us: dataCompany.client_information_us,
                    contact_us: dataCompany.client_information_contact_us
                },
                personalize:{
                    web_page: dataCompany.personalize_web_page,
                    mobile_app: dataCompany.personalize_mobile_app,
                    colors: self.colors,
                    app_logo: dataCompany.logo,
                    principal_sections: dataCompany.personalize_principal_sections,
                    secondary_sections: dataCompany.personalize_secundary_sections,
                    personalize_mails: dataCompany.personalize_personalize_mails
                },
                inside_request:{
                    payment_certificate: dataCompany.inside_request_payment_certificate,
                    work_certificate: dataCompany.inside_request_work_certificate,
                    contribution_certificate: dataCompany.inside_request_contribution_certificate
                },
                api_connections:{
                    crm: dataCompany.api_connections_crm,
                    end_points: dataCompany.api_connections_end_points
                },
                custom_forms:{
                    all_forms: dataCompany.custom_forms
                },
                payments:{
                    admin_payments: dataCompany.payments_admin_payments
                },
                forms:{
                    custom_forms: dataCompany.custom_forms
                },
                notifications:{
                    push_notifications: dataCompany.notifications_push_notifications,
                    whatsapp_messages: dataCompany.notifications_whatsapp_notifications
                },
                sgsst:{
                    general: dataCompany.sgsst_general
                },
                alarms:{
                    alarms: dataCompany.use_of_alarms
                },
                parcels: {
                    parcels_delivery: dataCompany.parcel_delivery
                },
                invitations:{
                    admin_invitations: dataCompany.invitations_admin_invitations
                }
                }
            dispatch("updateCompany",company)
            dispatch("updateCompanyLoaded",true)

            resolve();

            })

            } catch (e) {
              reject(e)
              alert(e.message)
            }

        });

    }
}

export default {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}



// WEBPACK FOOTER //
// ./src/vue/store/modules/session.js